import { Trans, useTranslation } from "react-i18next";
import { TRIGGER_TYPES } from "../builder/constants/triggers";

export default function IntegrationsActiveCampaignTriggerDetail({ flow }) {
  const { t } = useTranslation();
  const triggerData = TRIGGER_TYPES[flow.trigger_type];

  const timeline = [
    {
      id: 1,
      content: (
        <Trans i18nKey="flows:trigger-detail.integrations-activecampaign-step-1">
          Create an ActiveCampaign Automation with a{" "}
          <strong className="text-gray-800 font-medium">start trigger</strong>{" "}
          such as "Subscribes to a list", "Tag is added", or a custom trigger
          condition.
        </Trans>
      ),
    },
    {
      id: 2,
      content: (
        <Trans i18nKey="flows:trigger-detail.integrations-activecampaign-step-2">
          Add{" "}
          <strong className="text-gray-800 font-medium">action steps</strong> to
          update contact tags, custom fields, or other data you need to sync
          with your Hilos contact using the drag-and-drop builder.
        </Trans>
      ),
    },
    {
      id: 3,
      content: (
        <Trans i18nKey="flows:trigger-detail.integrations-activecampaign-step-3">
          Use a{" "}
          <strong className="text-gray-800 font-medium">WhatsApp action</strong>{" "}
          to trigger the WhatsApp flow in Hilos. You can use conditions and
          goals to control when the flow is triggered.
        </Trans>
      ),
    },
  ];

  return (
    <>
      <h3 className="text-tiny font-medium uppercase tracking-wider text-gray-500">
        {t("trigger", "Trigger")}
      </h3>
      <div className="flex items-center space-x-1">
        <div>
          <triggerData.icon className="h-6 w-6 text-gray-800" />
        </div>
        <div className="font-medium text-gray-900">
          <p className="text-xl">{t(triggerData.name)}</p>
        </div>
      </div>
      <div className="text-sm text-gray-700">
        <div className="flow-root">
          <ul className="-mb-4 mt-3">
            {timeline.map((event, eventIdx) => (
              <li key={event.id}>
                <div className="relative pb-4">
                  {eventIdx !== timeline.length - 1 ? (
                    <span
                      aria-hidden="true"
                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                    />
                  ) : null}
                  <div className="relative flex space-x-3 items-center">
                    <div>
                      <span className="flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white text-white bg-gray-400">
                        {event.id}
                      </span>
                    </div>
                    <div className="min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                      <div>
                        <p className="text-sm text-gray-500">{event.content}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
